<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form @submit="login">
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Login</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-text-field prepend-icon="person" name="email" label="Email" v-model="input.email"></v-text-field>
                <v-text-field prepend-icon="lock" name="password" label="Password" type="password" v-model="input.password"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="primary">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthService from '@/services/AuthService.js'
export default {
  name: 'Login',
  data () {
    return {
      input: {
        email: '',
        password: ''
      },
      error: ''
    }
  },
  mounted () {
    this.checkErrors()
  },
  methods: {
    checkErrors () {
      if (this.$route.params.error === 'unauthorized') {
        this.error = 'Unauthorized, please log in'
      }
    },
    async login (e) {
      e.preventDefault()
      if (this.input.email !== '' && this.input.password !== '') {
        const response = await AuthService.login({
          email: this.input.email,
          password: this.input.password
        })
        localStorage.setItem('id_token', response.data.id_token)
        localStorage.setItem('is_admin', response.data.is_admin)
        localStorage.setItem('user', response.data.user)
        this.$router.push('Dashboard')
      } else {
        console.log('A email and password must be present')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue